import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { KitchenService } from './kitchen.service';

export const Ng1KitchenModule = angular
  .module('control-room.commons.services.kitchen', [])
  .factory('crKitchenService', downgradeInjectable(KitchenService));